import React from "react";

export const Selector = ({
  label,
  options,
  selected,
  onSelect,
  optionKey = "name",
}) => (
  <div className="styling-wrap__type">
    <p className="marcellus-25-400">{label}</p>
    <div className="styling-wrap__type-items poppins-18-500">
      {options?.map((option, idx) => (
        <button
          key={idx}
          className={`styling-wrap__type-item poppins-18-500 ${
            selected?.[optionKey] === option[optionKey] ? "active" : ""
          }`}
          onClick={() => onSelect(option)}
        >
          {option[optionKey]}
        </button>
      ))}
    </div>
  </div>
);
